<template slot-scope="scope">
  <!-- 切换行业弹窗 -->
  <dialogModel
    title="选择行业类别"
    :visible.sync="dialogProfession"
    @handleClose="handleClose"
    @handleOk="handleUnderstand"
  >
    <div class="input-box">
      <el-select
          v-model="input"
          filterable
          remote
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
          :loading="loading"
          @change="pestChange"
          @blur="handleBlur" 
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :value="item.value"
            :label="item.label"
          >
          </el-option>
        </el-select>
    </div>
    <!-- 主体 -->
    <div class="main-body">
      <div class="left-menu">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="item.code == listSelect ? 'left-menu-Select' : ''"
          @click="handelClickMenu(item)"
        >
          {{ item.label }}
        </div>
      </div>
      <div class="right-Options">
        <!-- 右侧市级box -->
        <div class="MunicipalLevel-box">
          <p
            v-for="(item, index) in profession"
            :key="index"
            :class="item.lists == 1 ? 'TheCitySelect' : ''"
            @click="handelTheCitySelect(item)"
          >
            {{ item.label }}
          </p>
        </div>
      </div>
    </div>
    <!-- 选择回显 -->
    <!-- v-if="singleChoice != 2" -->
    <div class="Select-line">
      <p class="Select-Tips">
        已选择：<span style="color: #409eff ">{{ echoVal.length }}</span
        >/3
      </p>
      <div class="echo">
        <div class="data-echo" v-for="(item, index) in echoVal" :key="index">
          <p>{{ item.label }}</p>
          <div class="firm-clickable" @click="handelTheCitySelect(item)"></div>
        </div>
      </div>
    </div>
  </dialogModel>
</template>

<script>
import {
  postGetIndustryTypeSelect, // 行业
  findIndustryType, //行业搜索
} from "../assets/api/indexl";
export default {
  props: {
    dialogProfession: {},
    industryTypeList: {},
    singleChoice: {}, //行业单选
  },
  components: {},
  data() {
    return {
      input: "",

      list: [], // 行业数据
      listSelect: "0", //行业选中
      profession: [], // 职位数据
      professionSelect: "0", //职位选中

      echoVal: [], // 用于回显选中

      options: [],
      value: [],
      listInput: [],
      loading: false, // 加载....
      states: [], //  门类数据列表
      obj: {}, //搜索出的数据
    };
  },
  watch: {
    // 监听
    dialogProfession: {
      async handler(newSs) {
        if (newSs != true) return;
        // 先确保行业数据就绪，再做回显/默认选中，避免异步未完成时 list 为空
        await this.ensureIndustryList();
        this.applyIndustrySelection();
      },
    },
  },
  computed: {},
  created() {
    // 不再在created中加载，改为在弹窗打开时按需加载
  },
  methods: {
    async ensureIndustryList() {
      if (
        !this.$store.getters.getIndustry ||
        this.$store.getters.getIndustry.length === 0
      ) {
        await this.postGetIndustryTypeSelect();
      } else {
        this.list = this.$store.getters.getIndustry;
      }
    },
    applyIndustrySelection() {
      if (!this.list || this.list.length === 0) return;
      if (
        this.industryTypeList != undefined &&
        this.industryTypeList.length > 0
      ) {
        for (var i in this.industryTypeList) {
          for (var k in this.list) {
            for (var n in this.list[k].children) {
              if (
                this.list[k].children[n].code ==
                this.industryTypeList[i].code
              ) {
                this.list[k].children[n].lists = "1";

                this.echoVal[this.echoVal.length++] =
                  this.list[k].children[n];
                this.profession = this.list[k].children;
                this.listSelect = this.list[k].code;
              }
            }
          }
        }
      } else if (this.list[0]) {
        this.listSelect = this.list[0].code;
        this.profession = this.list[0].children;
      }
    },
    // 失去焦点清空下拉选项
    handleBlur() {
      // 延迟清空，防止选中值时被清空
      setTimeout(() => {
        this.options = [];
      }, 300);
    },
    // 选择 门类名称完毕 获取需要的值
    pestChange(val) {
      console.log(
        val,
        val.substring(val.lastIndexOf("-") + 1),
        val.substring(0, val.lastIndexOf("-"))
      );

      for (var i in this.list) {
        for (var k in this.list[i].children) {
          if (
            this.list[i].children[k].code ==
            val.substring(0, val.lastIndexOf("-"))
          ) {
            this.obj = this.list[i].children[k];
          }
        }
      }
      this.handelTheCitySelect(this.obj);
      // 使用 nextTick 确保选择完成后再清空选项
      this.$nextTick(() => {
        this.options = [];
        this.input = "";
        this.obj = {};
      });
    },
    // 门类 远程搜索
    async remoteMethod(query) {
      // 远程搜索前调用接口，传入搜索的数据获取门类
      var data = {};
      data.data = {
        name: query != "" ? query : "/",
      };
      if (data.data.keyword != "") {
        // 调用 获取门类接口
        await findIndustryType(data).then((res) => {
          this.states = res.data.list;
          this.listInput = this.states.map((item) => {
            return {
              value: `${item.code}-${item.name}`,
              label: `${item.parentName}-${item.name}`,
              id: `${item.code}`,
            };
          });
        });
      }
      // 组件 自带远程搜索的函数
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.listInput.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },

    // 获取行业类别
    async postGetIndustryTypeSelect() {
      // 调用获取行业接口
      const res = await postGetIndustryTypeSelect();
      this.list = res.data;
      this.$store.commit("SET_Industry", res.data);
    },
    //选择行业
    handelClickMenu(item) {
      // 一级行业选中
      this.listSelect = item.code;
      // 右侧展示的一级行业下的三级子行业
      this.profession = item.children;
    },

    // 选择 职位  下方已选择职位回显点击x取消选中
    handelTheCitySelect(item) {
      console.log(item, "11111");
      // 已选中
      // if (this.singleChoice != 2) {
      if (item.lists == 1) {
        item.lists = 0;
        for (var i in this.echoVal) {
          if (item.code == this.echoVal[i].code) {
            this.echoVal.splice(i, 1);
          }
        }
      } else {
        // 未选中
        if (this.echoVal.length >= 3) {
          console.log("已到最大可选择数量");
        } else {
          item.lists = 1;
          this.echoVal[this.echoVal.length++] = item;
        }
      }
      // } else {

      // }
    },

    // 弹窗关闭
    handleClose() {
      this.postGetIndustryTypeSelect();
      this.echoVal = [];
      this.$emit("handleClose", 1);
    },
    // 弹窗确认
    handleUnderstand() {
      // console.log(this.echoVal);
      this.$emit("handleUnderstand", 1, this.echoVal);
      this.echoVal = [];

      this.postGetIndustryTypeSelect();
    },
  },
};
</script>

<style scoped lang="less">
// 标题
.title {
  width: 100%;
  height: 90px;
  position: relative;
  display: flex;
  // 关闭按钮
  .Off-icon {
    width: 18px;
    height: 18px;
    background-image: url("../assets/imgs/guanbi.svg");
    background-size: 100% 100%;
    position: absolute;
    right: 10px;
    top: 10px;
  }
  .Text-title {
    height: 20px;
    width: 100px;
    line-height: 20px;
    margin: auto 0;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    font-weight: 400;
    margin-left: 30px;
  }
  // 搜索框
  .input-box {
    width: 340px;
    height: 30px;
    line-height: 30px;
    margin: auto 0;
    margin-left: 70px;
    display: flex;
    position: relative;
    // input框的样式
    /deep/.el-input__inner {
      width: 250px;
      font-size: 16px;
      line-height: 30px;
      height: 30px !important;
      border: 1px solid #409eff ;
      background: #ffffff;
      // position: absolute;
      border-radius: 10px;
      z-index: 1;
    }
    // 搜索按钮样式
    .search_btn {
      font-size: 16px;
      color: #ffffff;
      font-weight: 400;
      line-height: 30px;
      background-color: #409eff ;
      width: 100px;
      height: 30px;
      border-radius: 0px 10px 10px 0px;
      cursor: pointer;
      position: absolute;
      right: 0;
      display: flex;
      white-space: nowrap;
      div {
        width: 60px;
        height: 20px;
        line-height: 20px;
        margin: auto;
        display: flex;
        p {
          width: 20px;
          height: 20px;
          // background-image: url("../assets/imgs/sousuo@3x.svg");
          // background-size: 100% 100%;
          margin-right: 3px;
        }
      }
    }
  }
}
// 内容主体
.main-body {
  width: 100%;
  height: 350px;
  display: flex;
  border-bottom: 1px dashed #409eff ;
  .left-menu::-webkit-scrollbar {
    display: none;
  }
  .left-menu {
    width: 220px;
    height: 100%;
    margin-left: 5px;
    overflow: hidden;
    overflow-y: scroll;
    // 火狐隐藏滚动条
    scrollbar-width: none;
    cursor: pointer;
    div {
      width: 100%;
      height: 35px;
      line-height: 35px;
      text-align: center;
      margin-bottom: 10px;
      margin-top: 10px;
      background: #ffffff;
      border-radius: 10px 0px 0px 10px;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #333333;
      font-weight: 400;
    }
    .left-menu-Select {
      background: #eeeeee;
      color: #409eff ;
    }
  }
  .right-Options::-webkit-scrollbar {
    display: none;
  }
  .right-Options {
    overflow: hidden;
    overflow-y: scroll;
    // 火狐隐藏滚动条
    scrollbar-width: none;
    flex: 1;
    height: 100%;
    background: #eeeeee;
    // 市级 div
    .MunicipalLevel-box {
      margin: 20px 20px 0px 20px;
      display: flex;
      flex-wrap: wrap;
      p {
        padding-left: 8px;
        padding-right: 8px;
        min-width: 95px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #ffffff;
        border: 1px solid #979797;
        border-radius: 5px;
        margin-right: 18px;
        margin-bottom: 18px;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
      }
      .TheCitySelect {
        background: #409eff ;
        border: 1px solid #409eff ;
        color: #ffffff;
      }
    }
  }
}
// 回显选中的行业
.Select-line {
  width: 100%;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  .Select-Tips {
    height: 16px;
    line-height: 16px;
    margin-left: 30px;
    margin-top: 15px;
  }
  .echo {
    height: 30px;
    line-height: 30px;
    margin-top: 20px;
    margin-left: 30px;
    display: flex;
    .data-echo {
      min-width: 95px;
      height: 30px;
      background: #409eff ;
      border: 1px solid #409eff ;
      border-radius: 5px;
      font-size: 12px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      margin-right: 20px;
      display: flex;
      position: relative;
      p {
        padding-left: 8px;
        padding-right: 8px;
        min-width: 95px;
        height: 30px;
        margin: auto;
      }
      div {
        width: 18px;
        height: 18px;
        position: absolute;
        right: -8px;
        top: -8px;
        background-image: url("../assets/imgs/guanbi@3x.svg");
        background-size: 100% 100%;
      }
    }
  }
}
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}
</style>
